import { gql } from "@apollo/client";

const GET_NOMINATION_RELATED_IIAS = gql`
    query nominationRelatedIIAs(
        $homeErasmusCode: String!
        $hostErasmusCode: String!
    ) {
        nominationRelatedIIAs(
            homeErasmusCode: $homeErasmusCode
            hostErasmusCode: $hostErasmusCode
        ) {
            id
            iia_id
            uuid
            iia_status
            type_of_communication
            terminated
            created_time
            changed_time
            field_your_iia_id
            field_partner_iia_id
            cooperation_conditions {
                staff_teachers {
                    mobilities_per_year
                    other_info_terms
                    receiving_acad_year
                    receiving_contact {
                        contact_names
                        emails
                        person_family_names
                        person_given_names
                    }
                    receiving_hei_id
                    receiving_ounit_id
                    receiving_ounit_name
                    sending_contact {
                        contact_names
                        emails
                        person_family_names
                        person_given_names
                    }
                    sending_hei_id
                    sending_ounit_id
                    sending_ounit_name
                    subject_area {
                        isced_clarification
                        isced_f_code
                        isced_f_code_name
                    }
                    language_skill {
                        cefr_level
                        language
                    }
                    total_days_per_year
                }
                staff_trainings {
                    mobilities_per_year
                    other_info_terms
                    receiving_acad_year
                    receiving_contact {
                        contact_names
                        emails
                        person_family_names
                        person_given_names
                    }
                    receiving_hei_id
                    receiving_ounit_id
                    receiving_ounit_name
                    sending_contact {
                        contact_names
                        emails
                        person_family_names
                        person_given_names
                    }
                    sending_hei_id
                    sending_ounit_id
                    sending_ounit_name
                    subject_area {
                        isced_clarification
                        isced_f_code
                        isced_f_code_name
                    }
                    language_skill {
                        cefr_level
                        language
                    }
                    total_days_per_year
                }
                student_studies {
                    eqf_level
                    mobilities_per_year
                    other_info_terms
                    receiving_acad_year
                    receiving_contact {
                        contact_names
                        emails
                        person_family_names
                        person_given_names
                    }
                    receiving_hei_id
                    receiving_ounit_id
                    receiving_ounit_name
                    sending_contact {
                        contact_names
                        emails
                        person_family_names
                        person_given_names
                    }
                    sending_hei_id
                    sending_ounit_id
                    sending_ounit_name
                    subject_area {
                        isced_clarification
                        isced_f_code
                        isced_f_code_name
                    }
                    language_skill {
                        cefr_level
                        language
                    }
                    total_months_per_year
                    blended
                }
                student_traineeships {
                    eqf_level
                    mobilities_per_year
                    other_info_terms
                    receiving_acad_year
                    receiving_contact {
                        contact_names
                        emails
                        person_family_names
                        person_given_names
                    }
                    receiving_hei_id
                    receiving_ounit_id
                    receiving_ounit_name
                    sending_contact {
                        contact_names
                        emails
                        person_family_names
                        person_given_names
                    }
                    sending_hei_id
                    sending_ounit_id
                    sending_ounit_name
                    subject_area {
                        isced_clarification
                        isced_f_code
                        isced_f_code_name
                    }
                    language_skill {
                        cefr_level
                        language
                    }
                    total_months_per_year
                    blended
                }
            }
        }
    }
`;

export default GET_NOMINATION_RELATED_IIAS;